var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form-item',{attrs:{"label":"ID","size":"medium","required":_vm.isRequired}},[_c('div',[_vm._v(_vm._s(_vm.localValue))])])}
var staticRenderFns = []

export { render, staticRenderFns }